import * as _ from 'lodash';

import { Component, OnInit, AfterViewInit, AfterViewChecked, Input, Output, EventEmitter, ViewChildren, QueryList, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Sector, Booking, Addon, AddonOption, Totals } from '../../../../models/booking.model';
import * as moment from 'moment';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { DeleteSectorByGuidOptions, BookingService, DeleteSectorOptions } from '../../../../services/booking.service';
import { ActionUpdaterService, ApiError } from '../../../../services/action-updater.service';
import { ITINERARY_CONTEXT } from 'app/shared/models/enums/context.enum';
import { TimetableService } from 'app/shared/services/timetable-service';
import { PostTimetableOption, RouteOption } from 'app/shared/models/timetables.model';
import { FeatureService, Feature } from 'app/shared/services/feature.service';
import { GoogleMapComponent } from 'app/shared/components/google-map/google-map.component';
import { DeviceService } from '../../../../services/device.service';
import { SeatAllocation } from '../../../../services/travel.service';
import { SelectListDataItem } from '../../../select-list/select-list.component';

declare var jQuery: any;

@Component({
    selector: 'gaweb-sector',
    templateUrl: './sector.component.html',
    styles: [`
    .itinerary__sectors {
      margin-top: 5px;
    }
    .sector__date {
      padding: 5px;
      background-color: lightgray;
      margin-top: 5px;
    }
    .trip-details-button{
      min-width: 70px;
    }
    .delete-button{
      min-width: 100px;
    }
  `]
})
export class SectorComponent implements AfterViewInit, OnChanges {
    @Output() onSectorDeleted: EventEmitter<Booking> = new EventEmitter();
    @Output() onSeatsUpdated: EventEmitter<Array<SeatAllocation>> = new EventEmitter();
    @Input() sector: any;
    @Input() booking: Booking;
    @Input() isPass: boolean;
    @Input() allSectors: Sector[];
    @Input() productType: string;
    @Input() bookingGuid: string;
    @Input() scrollId: string;
    @Input() showTripDetails = false;
    @Input() showJustSectors: boolean;
    @Input() addons: Array<Addon>;
    @Input() addonsToPurchase: Array<AddonOption>;
    @Input() totals: Totals;
    @ViewChildren(GoogleMapComponent) googleMap: QueryList<GoogleMapComponent>;


    showDetailed = true;
    isMyGreyhound: boolean;
    mapEnabled = false;
    @Input()
    set context(c: ITINERARY_CONTEXT) {
        this.isMyGreyhound = c === ITINERARY_CONTEXT.MY_GREYHOUND;
    }
    gettingTimetable = false;
    deletingSector = false;
    ro: any;
    addonsAvailable: boolean;
    addonsFound: Addon[] = [];
    addonsFoundProductCodes: String[] = [];
    showExtendPass: boolean;

    constructor(public localStorageService: LocalStorageService,
        private actionUpdaterService: ActionUpdaterService,
        private bookingService: BookingService,
        private timetableService: TimetableService,
        private featureService: FeatureService,
        private deviceService: DeviceService) { }

    ngOnInit() {
        this.mapEnabled = this.featureService.GetFeatureStatus(Feature.UseGoogleMaps);

        if (this.sector.OpenDatedUntil !== false && this.sector.OpenDatedUntil != null) {
            this.showTripDetails = false;
        }

        if (this.sector.OpenDatedUntil == null) {
            //this.getTimetable(this.sector);
        }
    }
    
    ngAfterViewInit() {
        // console.log(this.booking);
        // console.log(this.addons);
    }

    ngOnChanges(changesObj: SimpleChanges): void {
    }

    seatsUpdate(seats){
        const selectedSeats = new Array<any>();
        seats.forEach((seat) => {
            if(seat.Status === 3) {
                seat.SeatLetter = seat.Seat;
                selectedSeats.push(seat);
            }
        });
        this.sector.Seats = selectedSeats;
    }
    checkMaps(sector) {
        // Wait until map is ready.
        if (this.googleMap) {
            this.googleMap.forEach((gmap) => {
                gmap.refreshMap();
        });
        } else {
            setTimeout(() => {
                this.checkMaps(sector);
            }, 250);
        }
    }

    purchaseMask(sector: any) {
        console.log('Purchase ' + sector.Seats.length + ' Masks for ' + sector.ServiceCompany + sector.ServiceNumber);
    }
    
    getFareTypeDescription(sector: Sector) {
        return (sector.FareType == null || sector.FareType == '') ? sector.SpecialType : sector.FareType;
    }

    updateSector(sector: Sector) {
        sector.displayChangeDate = !sector.displayChangeDate;
    }

    getTimetable(sector: Sector) {

        this.gettingTimetable = true;
        const getTimetableOption = new PostTimetableOption(sector.ServiceNumber, sector.OriginStopCode, sector.DestinationStopCode),
            timetableDate = moment(sector.PassengerBoardingDate, 'DD/MM/YYYY h:mm:ss A').format('DD-MMM-YYYY');

        if (!!sector.timetable) {
            sector.timetable[0].mapView = false;
            sector.timetableDisplayed = !sector.timetableDisplayed;
            this.gettingTimetable = false;
        } else {
            this.timetableService.postTimetable([getTimetableOption], timetableDate).subscribe(
                (timetable) => {
                    timetable[0].mapView = false;
                    this.gettingTimetable = false;
                    sector.timetable = timetable;
                    sector.timetableDisplayed = true;
                    sector.timetable[0].mapView = false;
                    sector.timetable[0].showMap = (inputRo) => {
                        sector.timetable[0].mapView = true;
                        this.checkMaps(inputRo);
                    };
                }, this.onError
            )
        }
    }

    onError = (error) => {
        console.error(error);
        this.gettingTimetable = false;
        this.actionUpdaterService.onError(error);
    }
    deleteSector(sector: Sector) {
        this.deletingSector = true;
        const deleteSectorOptions = new DeleteSectorOptions(
            this.bookingGuid,
            sector.SectorNumber);
        this.bookingService.deleteSector(deleteSectorOptions).subscribe(
            (booking: Booking) => {
                this.deletingSector = false;
                if (this.deviceService.IsMobile()) {
                    jQuery('html, body').animate({
                        scrollTop: jQuery('.itinerary').position().top + 20 + parseInt(jQuery('.navbar').css('height').replace(/\D/g, ''), 10)
                    }, 500);
                }
                this.booking.Sectors = this.booking.Sectors.filter(x => x != sector);
                this.onSectorDeleted.emit(booking);
            },
            (error) => {
                this.deletingSector = false;
                this.actionUpdaterService.onError(error);
            }
        );
    }
    getSectorDivId(guid: string): string {
        return guid.replace(/-/g, '');
    }

    showDetailedTrip() {
        if(this.sector.timetable == null && this.showDetailed){
            this.getTimetable(this.sector);
            this.showDetailed = !this.showDetailed;
        } else {
            this.showDetailed = !this.showDetailed;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/sector/sector.component.ts